import type { OfflineVault } from './offline';
/** Explicit encrypted export only: no clinical text in the filename or browser cache. */
export async function downloadOfflineRecovery(vault: OfflineVault) {
  const file = await vault.exportRecovery();
  const url = URL.createObjectURL(new Blob([file], { type: 'application/json' }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'mohair-encrypted-offline-recovery.json';
  anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
